import type { FsTypeCategory, PeriodType } from "@/apis/compare/types";

export const DEFAULT_PERIOD_ORDER: readonly PeriodType[] = [
  "CURRENT",
  "PREVIOUS",
  "BEFORE_PREVIOUS",
] as const;

const OLDEST_FIRST_PERIOD_ORDER: readonly PeriodType[] = [
  "BEFORE_PREVIOUS",
  "PREVIOUS",
  "CURRENT",
] as const;

// 자본변동표(CE)는 ixd 엑셀 추출 관행상 전기가 당기보다 먼저 표시되므로,
// 다른 재무제표(당기 우선)와 반대로 과거→현재 순으로 정렬한다.
const OLDEST_FIRST_FS_TYPES: ReadonlySet<FsTypeCategory> = new Set(["CE"]);

export const getDisplayPeriodOrder = (
  fsTypeCategory?: FsTypeCategory | null,
): readonly PeriodType[] =>
  fsTypeCategory && OLDEST_FIRST_FS_TYPES.has(fsTypeCategory)
    ? OLDEST_FIRST_PERIOD_ORDER
    : DEFAULT_PERIOD_ORDER;
